var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { InfoCircleOutlined } from '@ant-design/icons';
import { GeofenceType } from '@tenderd/schema';
import { Button, Form, Input, Modal, Row, Select } from 'antd';
import _ from 'lodash';
import React from 'react';
import { GroupGeofenceAction, useGroupGeofencePageContext, } from '../../GroupGeofencePage.context';
import './PostGeofence.style.css';
import DeleteGeoFence from './components/DeleteGeoFence';
import usePostGeofence from './usePostGeofence';
var PostGeofence = function () {
    var hook = usePostGeofence();
    var context = useGroupGeofencePageContext();
    return (React.createElement(React.Fragment, null,
        !context.mode && (React.createElement(Button, { type: "primary", onClick: function () {
                context.setGeofenceAction(GroupGeofenceAction.AddGeofence);
                context.setPostGeofenceModal(true);
            } }, "Add New Geofence")),
        React.createElement(Modal, { className: "add-geofence-modal", open: context.postGeofenceModal, centered: true, closable: false, width: 380, footer: [
                React.createElement(React.Fragment, null,
                    React.createElement(Row, { align: 'middle', wrap: false },
                        React.createElement(Button, { key: "submit", type: "primary", loading: hook.loading, onClick: hook.form.submit }, context.geofenceAction ===
                            GroupGeofenceAction.UpdateGeofence
                            ? 'Save Changes'
                            : 'Create'),
                        React.createElement(Button, { key: "back", disabled: hook.loading, onClick: function () {
                                return context.setPostGeofenceModal(false);
                            } }, "Cancel")),
                    React.createElement(DeleteGeoFence, null)),
            ] },
            React.createElement(Form, { form: hook.form, layout: "vertical", onFinish: hook.onSubmit, requiredMark: false, initialValues: hook.defaultValues },
                React.createElement(Form.Item, { rules: [{ required: true }], style: { marginBottom: 16 }, label: "Name", name: 'name' },
                    React.createElement(Input, { placeholder: "Geofence Name" })),
                React.createElement(Form.Item, { rules: [{ required: true }], style: { marginBottom: 16 }, label: "Type", name: 'type' },
                    React.createElement(Select, { onChange: function () {
                            hook.form.setFieldsValue({
                                allowedEquipmentTypes: [],
                            });
                        }, placeholder: "Select type", options: [
                            GeofenceType.Standard,
                            GeofenceType.Restricted,
                        ].map(function (type) { return ({
                            value: type,
                            label: type,
                        }); }) })),
                hook.typeValue === GeofenceType.Restricted && (React.createElement(React.Fragment, null,
                    React.createElement(Form.Item, { label: "Allowed Equipment Type", name: 'allowedEquipmentTypes' },
                        React.createElement(Select, { mode: "multiple", placeholder: "Select relevent group/sub group", options: __spreadArray([
                                hook.EquipmentTypes.length && {
                                    value: 'all',
                                    label: 'Select All',
                                }
                            ], __read(hook.EquipmentTypes.map(function (equipment) { return ({
                                value: equipment,
                                label: _.capitalize(equipment),
                            }); })), false).filter(function (e) { return e; }) })),
                    React.createElement("p", { className: "equipment-info" },
                        React.createElement(InfoCircleOutlined, null),
                        React.createElement("span", null, "Only the specified equipment type(s) are permitted in the restricted zone without being marked as a violation."))))))));
};
export default PostGeofence;
